"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LabelText = require("./LabelText.styles");

var _propTypes2 = _interopRequireDefault(require("../../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources

/**
 * LabelText - for when you need a label and want it to look like those on the input fields
 */
// intentionally left as a functional component
var LabelText = function LabelText(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dataTestId = _ref.dataTestId,
      idFor = _ref.idFor;
  return /*#__PURE__*/_react.default.createElement(_LabelText.StyledLabel, {
    className: className,
    dataTestId: dataTestId
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: idFor
  }, children));
};

LabelText.propTypes = {
  /** children components or just plain old text */
  children: _propTypes2.default.children.isRequired,

  /** className hook for styling */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** id of field for which the label can be paired matched */
  idFor: _propTypes.default.string
};
LabelText.defaultProps = {
  className: '',
  idFor: undefined
};
var _default = LabelText;
exports.default = _default;